import { GameConstants } from "../../../GameConstants";
import { RoadManager } from "../Roadmanager";
import { GameVars } from "../../../GameVars";
import { StageContainer } from "../StageContainer";
import { AudioManager } from "../../../AudioManager";
import { ControlsInstructionsLayer } from "../ControlsInstructionsLayer";


    export class Chicken extends Phaser.Group {

        private static SPEED_MAX = 3;
        private static SPEED_OFF = 3;

        private static LEFT_RIVER = GameConstants.GAME_WIDTH / 2 - 85;
        private static TRUNKS_1 = GameConstants.GAME_WIDTH / 2 - 25 + 3;
        private static TRUNKS_2 = GameConstants.GAME_WIDTH / 2 + 25 + 3;
        private static RIGHT_RIVER = GameConstants.GAME_WIDTH / 2 + 98;

        public chickenSprite: Phaser.Sprite;
        public haveCone: boolean;

        private arrow: Phaser.Image;
        private destroyNextFrame: boolean;
        private saved: boolean;
        private canMove: boolean;
        private jumpKey: Phaser.Key;
        private jumping: boolean;
        private speedX: number;
        private speedY: number;
        private counterSound: number;
        private animIdle: Phaser.Animation;
        private animWalk: Phaser.Animation;
        private animRun: Phaser.Animation;
        private animCone: Phaser.Animation;
        private animConeIdle: Phaser.Animation;
        private animJump: Phaser.Animation;
        private finalX: number;
        private canCloseCall: boolean;
        private firstCloseCall: boolean;
        private prevX: number;
        private prevY: number;
        private canJump: boolean;

        constructor(game: Phaser.Game, newScale?: number) {

            super(game, null, "chicken");

            RoadManager.newTime();

            newScale = newScale || 1;

            this.destroyNextFrame = false;
            this.saved = false;

            this.prevX = 0;
            this.prevY = 0;

            this.speedX = 0;
            this.speedY = 0;
            this.counterSound = 20;
            this.jumping = false;
            this.finalX = GameConstants.GAME_WIDTH - 90 + Math.random() * 50;
            this.canCloseCall = false;
            this.firstCloseCall = true;
            this.canMove = false;
            this.haveCone = false;
            this.canJump = true;

            this.chickenSprite = this.create(0, 0, "texture_atlas_1", "chicken_idle_0001.png");
            this.chickenSprite.name = GameConstants.CHICKEN;
            this.game.physics.enable(this, Phaser.Physics.ARCADE);

            const body = <Phaser.Physics.Arcade.Body> this.chickenSprite.body;
            body.setSize(30, 2, 12, 65);
          
            this.animIdle = this.chickenSprite.animations.add("idle", Phaser.Animation.generateFrameNames("chicken_idle_", 1, 16, ".png", 4));
            this.animWalk = this.chickenSprite.animations.add("walk", Phaser.Animation.generateFrameNames("chicken_test_walk_", 1, 16, ".png", 4));
            this.animRun = this.chickenSprite.animations.add("run", Phaser.Animation.generateFrameNames("chicken_test_run_", 1, 16, ".png", 4));
            this.animJump = this.chickenSprite.animations.add("jump", Phaser.Animation.generateFrameNames("chicken_jump_", 1, 1, ".png", 4));

            this.chickenSprite.play("idle", 20, true);
            this.changeFrameRate();

            this.chickenSprite.anchor.set(.5, 1);
            this.chickenSprite.scale.set(newScale);

            this.addArrow();

            if (!/Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent)) {
                this.jumpKey = this.game.input.keyboard.addKey(Phaser.Keyboard.SPACEBAR);
                this.jumpKey.onDown.add(this.jump, this);
            }
        }

        public update(): void {

            super.update();

            if (GameVars.paused || !this.canMove) {
                return;
            }

            if (!/Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent)) {
                this.moveDesktop();
            }

            if (this.arrow && (this.speedX || this.speedY)) {
                this.arrow.destroy();
                this.arrow = null;
            }

            let speedFreeze = GameVars.freezeAction ? .15 : 1;
            let speedBoots = GameVars.featherSpeed ? 2 : 1;

            if (GameVars.riverSide === GameConstants.RIVER_IN) {
                this.speedX = 0;
            }

            if (GameVars.riverSide === GameConstants.RIVER_IN) {
                if (GameVars.trunksLine === GameConstants.RIVER_LANE_0) {
                    this.y += StageContainer.TRUNKS_VEL_0;
                } else if (GameVars.trunksLine === GameConstants.RIVER_LANE_1) {
                    this.y += StageContainer.TRUNKS_VEL_1;
                } else if (!this.jumping) {
                    RoadManager.onChickenDrowned();
                }
            }
            
            this.x += this.speedX * speedFreeze * speedBoots;
            this.y += (this.speedY * speedFreeze * speedBoots) / 2;

            if (GameVars.riverSide === GameConstants.RIVER_LEFT && this.x > Chicken.LEFT_RIVER && this.scale.x === 1) {
                this.x = Chicken.LEFT_RIVER;
            } else if (GameVars.riverSide === GameConstants.RIVER_RIGHT && this.x < Chicken.RIGHT_RIVER && this.scale.x === -1) {
                this.x = Chicken.RIGHT_RIVER;
            }

            if (this.game) {
                if (!(this.game.input.keyboard.isDown(Phaser.Keyboard.LEFT) || this.game.input.keyboard.isDown(Phaser.Keyboard.A)) && !((this.game.input.keyboard.isDown(Phaser.Keyboard.RIGHT) || this.game.input.keyboard.isDown(Phaser.Keyboard.D)))) {
                    this.canJump = true;
                }
    
                if (!this.jumping && this.canJump) {
                    if (this.x === Chicken.LEFT_RIVER && this.scale.x === 1 && (this.game.input.keyboard.isDown(Phaser.Keyboard.RIGHT) || this.game.input.keyboard.isDown(Phaser.Keyboard.D)) ) {
                        this.jump();
                        this.canJump = false;
                    } else if (this.x === Chicken.RIGHT_RIVER && this.scale.x === -1 && (this.game.input.keyboard.isDown(Phaser.Keyboard.RIGHT) || this.game.input.keyboard.isDown(Phaser.Keyboard.D))) {
                        this.jump();
                        this.canJump = false;
                    } else if (this.x > Chicken.LEFT_RIVER && this.x < Chicken.RIGHT_RIVER && ((this.game.input.keyboard.isDown(Phaser.Keyboard.RIGHT) || this.game.input.keyboard.isDown(Phaser.Keyboard.D)) || (this.game.input.keyboard.isDown(Phaser.Keyboard.LEFT) || this.game.input.keyboard.isDown(Phaser.Keyboard.A)))) {
                        this.jump();
                        this.canJump = false;
                    }
                }
            }            
            
            if (this.x < 10) {
                this.x = 10;
            }

            if (this.y < 40) {
                this.y = 40;
            } else if ( this.y > GameConstants.GAME_HEIGHT - 5) {
                this.y = GameConstants.GAME_HEIGHT - 5;
            }

            if (this.destroyNextFrame) {
                this.destroy();
            }

            if (!this.saved) {
                if (this.x > this.finalX) {
                    this.saved = true;
                    RoadManager.onChickenSaved(this.x, this.y);
                }
            }

            if ((this.speedX !== 0 || this.speedY !== 0) && (this.prevX - this.x !== 0 || this.prevY - this.y !== 0)) {

                if (!this.jumping) {
                    if (!this.haveCone) {
                        if (this.chickenSprite.animations.currentAnim !== this.animWalk && !GameVars.featherSpeed) {
                            this.chickenSprite.play("walk", 60, true);
                            this.changeFrameRate();
                        } else if (this.chickenSprite.animations.currentAnim !== this.animRun && GameVars.featherSpeed) {
                            this.chickenSprite.play("run", 60, true);
                            this.changeFrameRate();
                        }
                    } else if (this.chickenSprite.animations.currentAnim !== this.animCone && this.haveCone) {
                        // this.pedestrianSprite.play("cone", 60, true);
                        this.changeFrameRate();
                    }
                }

                if (this.counterSound === 20) {
                    this.counterSound = 0;
                    AudioManager.playSound("walk" + GameVars.randomDataGenerator.integerInRange(1, 4));
                } else {
                    this.counterSound++;
                }
            } else {
                this.counterSound = 20;

                if (!this.jumping) {
                    if (this.chickenSprite.animations.currentAnim !== this.animIdle && !this.haveCone) {
                        this.chickenSprite.play("idle", 60, true);
                        this.changeFrameRate();
                    } else if (this.chickenSprite.animations.currentAnim !== this.animConeIdle && this.haveCone) {
                        // this.pedestrianSprite.play("coneIdle", 60, true);
                        this.changeFrameRate();
                    }
                }
            }

            this.prevX = this.x;
            this.prevY = this.y;
        }

        public moveDesktop(): void {

            if (this.game.input.keyboard.isDown(Phaser.Keyboard.LEFT) || this.game.input.keyboard.isDown(Phaser.Keyboard.A)) {
                if (this.speedX > -Chicken.SPEED_MAX) {
                    this.speedX -= Chicken.SPEED_OFF;
                }
                this.scale.x = -1;
                this.checkIfTutorialIsShown();
            } else if (this.game.input.keyboard.isDown(Phaser.Keyboard.RIGHT) || this.game.input.keyboard.isDown(Phaser.Keyboard.D)) {
                if (this.speedX < Chicken.SPEED_MAX) {
                    this.speedX += Chicken.SPEED_OFF;
                }
                this.scale.x = 1;
                this.checkIfTutorialIsShown();
            } else {
                if (this.speedX > 0) {
                    this.speedX -= Chicken.SPEED_OFF;

                    if (this.speedX < 0) {
                        this.speedX = 0;
                    }
                } else if (this.speedX < 0) {
                    this.speedX += Chicken.SPEED_OFF;

                    if (this.speedX > 0) {
                        this.speedX = 0;
                    }
                } 
            }

            if (this.game.input.keyboard.isDown(Phaser.Keyboard.UP) || this.game.input.keyboard.isDown(Phaser.Keyboard.W)) {
                if (this.speedY > -Chicken.SPEED_MAX) {
                    this.speedY -= Chicken.SPEED_OFF;
                }
                this.checkIfTutorialIsShown();
            } else if (this.game.input.keyboard.isDown(Phaser.Keyboard.DOWN) || this.game.input.keyboard.isDown(Phaser.Keyboard.S)) {
                if (this.speedY < Chicken.SPEED_MAX) {
                    this.speedY += Chicken.SPEED_OFF;
                }
                this.checkIfTutorialIsShown();
            } else {
                if (this.speedY > 0) {
                    this.speedY -= Chicken.SPEED_OFF;

                    if (this.speedY < 0) {
                        this.speedY = 0;
                    }
                } else if (this.speedY < 0) {
                    this.speedY += Chicken.SPEED_OFF;

                    if (this.speedY > 0) {
                        this.speedY = 0;
                    }
                }
            }
        }

        public move(x: number, y: number): void {

            this.speedX = Chicken.SPEED_OFF * x;
            this.speedY = Chicken.SPEED_OFF * y;

            if (x < 0) {
                this.scale.x = -1;
            } else if (x > 0) {
                this.scale.x = 1;
            }
        }

        public jump(): void {

            if (GameVars.paused || this.arrow || this.jumping || !this.game) {
                return;
            }

            this.checkIfTutorialIsShown();

            this.jumping = true;

            let time = 100;

            if (GameVars.freezeAction) {
                time /= .15;
                this.canCloseCall = true;
            }

            let newX = this.x + 50 * this.scale.x;

            if (this.x >= Chicken.LEFT_RIVER - 20 && this.x <= Chicken.LEFT_RIVER && this.scale.x === 1) {
                GameVars.riverSide = GameConstants.RIVER_IN;
                newX = Chicken.TRUNKS_1;
            } else if (this.x > Chicken.TRUNKS_1 - 5 && this.x < Chicken.TRUNKS_1 + 5 && this.scale.x === -1) {
                GameVars.riverSide = GameConstants.RIVER_LEFT;
                newX = Chicken.LEFT_RIVER;
            } else if (this.x > Chicken.TRUNKS_2 - 5 && this.x <  Chicken.TRUNKS_2 + 5 && this.scale.x === 1) {
                GameVars.riverSide = GameConstants.RIVER_RIGHT;
                newX = Chicken.RIGHT_RIVER;
            } else if (this.x >= Chicken.RIGHT_RIVER && this.x <= Chicken.RIGHT_RIVER + 20 && this.scale.x === -1) {
                GameVars.riverSide = GameConstants.RIVER_IN;
                newX = Chicken.TRUNKS_2;
            }

            this.game.add.tween(this)
                .to({x: newX}, time, Phaser.Easing.Linear.None, true)
                .onComplete.add(function(): void {
                    this.jumping = false;

                    if (this.canCloseCall && this.firstCloseCall && !GameVars.freezeAction) {
                        if (this.game) {
                            this.game.time.events.add(200, this.closeCall, this);
                            this.canCloseCall = false;
                            this.firstCloseCall = false;
                        }    
                    }
                }, this);

            this.chickenSprite.play("jump", 60);
            this.changeFrameRate();
        }

        public closeCall(): void {
            if (this.game) {
                RoadManager.onCloseCall(this.x, this.y);
            }
        }

        public changeFrameRate(): void {

            let speedFreeze = GameVars.freezeAction ? .15 : 1;
            let speedBoots = GameVars.featherSpeed ? 2 : 1;

            this.animIdle.speed = 20 * speedBoots * speedFreeze;
            this.animJump.speed = 10 * speedBoots * speedFreeze;
            this.animWalk.speed = 60 * speedBoots * speedFreeze;
            this.animRun.speed = 60 * speedBoots * speedFreeze;
        }

        public kill(): void {

            this.destroyNextFrame = true;
        }

        private addArrow(): void {

            this.arrow = new Phaser.Image(this.game, 0, -60, "texture_atlas_1", "arrow.png");
            this.arrow.anchor.set(.5, 1);
            this.add(this.arrow);

            this.game.time.events.add(500, function(): void {
                this.canMove = true;
            }, this);

            this.game.add.tween(this.arrow)
                .to({y: [-65, -60]}, 250, Phaser.Easing.Linear.None, true, 0, -1);
        }

        private checkIfTutorialIsShown(): void {

            if(ControlsInstructionsLayer.currentInstance !== null){
                RoadManager.removeInstructionsLayer();
            }
        }
    }
